import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Fonds} from '../../../../models/fonds';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {ThemeService, UiConfigService} from '@lv1871/core';
import {FondsService} from '../../../../services/fonds.service';

export interface AnlaufmanagementlFonds {
  fondsId: number;
  name: string;
  isin: string;
  risikoklasse: number;
  factsheet: string;
  esgreport: string;
}

export class ModalDialogAnlaufmanagementInput {
  public anlaufFonds: AnlaufmanagementlFonds[];
  public selectedFonds: number;
}

@Component({
    selector: 'lv-modal-dialog-anlaufmanagement',
    templateUrl: './modal-dialog-anlaufmanagement.component.html',
    styleUrls: ['./modal-dialog-anlaufmanagement.component.scss'],
    standalone: false
})
export class ModalDialogAnlaufmanagementComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort)
  private _sort: MatSort;

  public displayedColumns: string[] = ['selected', 'name', 'risikoklasse', 'esgEinstufungTVO', 'factsheet', 'esgreport'];
  public selectedFonds: number;
  public dataSource: MatTableDataSource<AnlaufmanagementlFonds>;

  constructor(private _fondsService: FondsService, public dialogRef: MatDialogRef<ModalDialogAnlaufmanagementComponent>,
              private _themeService: ThemeService,
              private _uiConfigService: UiConfigService, @Inject(MAT_DIALOG_DATA) public data: ModalDialogAnlaufmanagementInput) { }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.data.anlaufFonds);
    this.selectedFonds = this.data.selectedFonds;
  }

  ngAfterViewInit(): void {
    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
      const value = data[sortHeaderId];
      if (typeof value === 'string') {
        return value?.toLowerCase().replace('ö', 'o').replace('ü', 'u').replace('ä', 'a');
      }
      return data[sortHeaderId];
    };
    this.dataSource.sort = this._sort;

    this._themeService.setApplicationTheme(
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-primary'),
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-secondary'),
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-warn'), null,
        'mdc-dialog__container'
    );
  }

  public closeDialog(): void {
    this.dialogRef.close(undefined);
  }

  fondsUebernehmen() {
    this.dialogRef.close(this.selectedFonds);
  }

  getLink(schriftstueckArt: string, fondsId: number): string {
    return this._fondsService.getLink(schriftstueckArt, fondsId);
  }

  selectFonds(fondsId: number): void {
    this.selectedFonds = fondsId;
  }
}
